"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stableSort = exports.getComparator = void 0;
function floatDeFormat(floatString) {
    var newFloatString = '';
    // logic by paring separator bcs rerender of dataTable did not work and
    // therefore change to other language does not immediately result in
    // formatted dataTable values (even though "shownRows" #).
    var separator = floatString.length >= 3 ? floatString.substr(floatString.length - 3, 1) : undefined;
    if (separator === ',') {
        newFloatString = floatString.replace(/\./g, '').replace(',', '.');
    }
    else if (separator === '.') {
        newFloatString = floatString.replace(/,/g, '');
    }
    else {
        newFloatString = floatString;
    }
    return parseFloat(newFloatString);
}
function descendingComparator(a, b, orderBy, numeric) {
    var aVal = numeric ? floatDeFormat(a.values[orderBy].split(' ')[0]) : a.values[orderBy].toLowerCase();
    var bVal = numeric ? floatDeFormat(b.values[orderBy].split(' ')[0]) : b.values[orderBy].toLowerCase();
    if (bVal < aVal) {
        return -1;
    }
    if (bVal > aVal) {
        return 1;
    }
    return 0;
}
function getComparator(order, orderBy, numeric) {
    return order === 'desc'
        ? function (a, b) { return descendingComparator(a, b, orderBy, numeric); }
        : function (a, b) { return -descendingComparator(a, b, orderBy, numeric); };
}
exports.getComparator = getComparator;
function stableSort(array, comparator) {
    var stabilizedThis = array.map(function (el, index) { return [el, index]; });
    stabilizedThis.sort(function (a, b) {
        var order = comparator(a[0], b[0]);
        if (order !== 0)
            return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(function (el) { return el[0]; });
}
exports.stableSort = stableSort;
//# sourceMappingURL=logic.js.map